export const API_URL =
  process.env.REACT_APP_API_URL || "https://api.getnovala.com";

export const getToken = (): string =>
  localStorage.getItem("access_token") || localStorage.getItem("token") || "";

export const authHeaders = (): Record<string, string> => {
  const token = getToken();
  return {
    "Content-Type": "application/json",
    Authorization: token ? "Bearer " + token : "",
  };
};

export interface MoneyParts {
  d: string;
  c: string;
}

export const money = (v: number | string | null | undefined): MoneyParts => {
  if (v == null || v === "") return { d: "", c: "" };
  const [d, c] = Number(v).toFixed(2).split(".");
  return { d, c };
};